import { render, staticRenderFns } from "./diagramMsgCopy.vue?vue&type=template&id=0d47f95a&scoped=true"
import script from "./diagramMsgCopy.vue?vue&type=script&lang=js"
export * from "./diagramMsgCopy.vue?vue&type=script&lang=js"
import style0 from "./diagramMsgCopy.vue?vue&type=style&index=0&id=0d47f95a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47f95a",
  null
  
)

export default component.exports